import { Tool } from './Tool'
import { Draw } from 'ol/interaction'
import GeometryType from 'ol/geom/GeometryType'
import VectorSource from 'ol/source/Vector'
import Geometry from 'ol/geom/Geometry'

export default class MeasureTool extends Tool {
    private measureInteraction!: Draw;

    public removeInteractions(): void {
        if (this.measureInteraction) { this.state.map?.removeInteraction(this.measureInteraction) }
    }

    public addInteractions(): void | Error {
        if (!this.state.imageInfo.scale || this.state.imageInfo.scale <= 0) {
            throw new Error('viewer.annotations.errors.notscalefound')
        }

        this.measureInteraction = new Draw({
            source: this.state.vectorSource as VectorSource<Geometry>,
            type: GeometryType.LINE_STRING,
            condition: this.manageClickEvent
        })

        this.state.map?.addInteraction(this.measureInteraction)

        this.measureInteraction.on('drawend', (evt) => {
            this.annotationManager.applyAnnotationDetails(evt.feature, false)
        })
    }
}
